var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarkerIconPharmacy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26 26"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M16.107 6a3.896 3.896 0 0 1 2.753 6.648l-6.212 6.213A3.869 3.869 0 0 1 9.894 20 3.868 3.868 0 0 1 7.14 18.86 3.869 3.869 0 0 1 6 16.107c0-1.04.406-2.018 1.14-2.753l6.214-6.214A3.865 3.865 0 0 1 16.107 6zm1.906 1.987a2.68 2.68 0 0 0-1.906-.789c-.72 0-1.398.28-1.906.79l-3.106 3.107 3.811 3.81 3.107-3.105a2.677 2.677 0 0 0 .788-1.907c0-.72-.279-1.397-.788-1.906zm-3.696 3.061-.634.635.634.635.636-.635zm1.483.635.636-.635.635.635-.635.635zm.636-2.753-.636.635.636.635.635-.635zm-2.753.635.634-.635.636.635-.636.635z",
    clipRule: "evenodd"
  })));
}
export default SvgMarkerIconPharmacy;